module.exports = __webpack_public_path__ + "aa.no1.a6cc01e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/aa.no1.jpg
// module id = m9mC
// module chunks = 0